/** Turkce icerik. Mod adlari `tr.json` katalogunu izler. */
import type { LanguageContent } from '../registry.js';

export const TR: LanguageContent = {
  home: {
    intro: [
      'Retusch, 2 ile 10 oyuncu için bir çevrimiçi çizim oyunudur; tarayıcıda oynanır, kurulum ve hesap gerektirmez. Her turda bir alanı silinmiş bir tablo alırsın: o alanı, eserin içinde kaybolacak şekilde yeniden çiz. Sonra roller değişir ve sıra ötekilerin rötuşlarını yakalamaya gelir.',
      'Neredeyse bütün çizim oyunları en çabuk tanınanı ödüllendirir. Retusch tam tersini ister: kazanmak, görülmemek demektir.',
    ],
    steps: [
      {
        title: 'Delikli bir tablo',
        text: 'Bir alanı silinmiş bir çizim alırsın.',
        painting: '1_airIsland',
        stage: 'masked',
      },
      {
        title: 'Yeniden çizersin',
        text: 'Alanı, esere karışacak biçimde yeniden çizersin.',
        painting: '1_airIsland',
        stage: 'painted',
      },
      {
        title: 'Av',
        text: 'Tablo herkesin rötuşuyla birlikte döner: onları ötekilerden önce bul.',
        painting: '1_airIsland',
        stage: 'hunt',
      },
      {
        title: 'Açığa çıkış',
        text: 'Her saklanma yeri ortaya çıkar ve puanlar dökülür.',
        painting: '1_airIsland',
        stage: 'reveal',
      },
    ],
    modes: [
      {
        name: 'Ortak av',
        text: 'Herkes aynı tabloya çizer, her biri kendi alanına. Sonra av herkes için aynı anda açılır: bir rötuş yalnızca bir kez bulunur, onu ilk fark eden tarafından. Varsayılan mod bu, sürekli bir şeylerin olduğu mod.',
      },
      {
        name: 'Yayın',
        text: 'Kurucu çizmez: herkes onun tablosunda saklanırken o tek başına arar. Canlı yayın için tasarlandı; burada gösteri avın kendisidir. Sonsuza kadar ücretsiz.',
      },
      {
        name: 'Herkese kendi tablosu',
        text: 'Oyuncu başına bir eser. Tek bir kişinin rötuşunu, tek bir tıklamayla ararsın. Oyunun en yalın kuralı, ve en gergini.',
      },
      {
        name: 'Tek kişi çizer',
        text: 'Bir tur, bir çizen, geri kalan herkes peşinde. Rol sırayla dolaşır ve çizen, saklanma yerinin düşüşünü ya da direnişini izler.',
      },
      {
        name: 'Battle royale',
        text: 'Aynı av, ama ilk bulunan rötuş sahibini eler. Son kalan kişiye kadar oynanır ve tek bir puan bile sayılmaz.',
      },
      {
        name: 'Yarışma',
        text: 'Kimse aramaz. Herkes aynı tablonun aynı alanını yeniden çizer, sonra herkes en beğendiği rötuşa oy verir. Alınan her oy bir puan değerindedir.',
      },
    ],
    faq: [
      {
        question: 'Kaç oyuncu gerekiyor?',
        answer:
          '2 ile 10 arası. Tek başınaysan boş koltuğu otomatik bir rakip doldurur, oyun hemen başlasın diye. Dört kişiden sonra ortak av en iyi halini gösterir.',
      },
      {
        question: 'Ücretsiz mi?',
        answer:
          'Evet. Hızlı oyun, ortak av ve yayın modu ücretsizdir; süre sınırı da oyun sayısı sınırı da yoktur. Öteki modlar da şimdilik ücretsiz.',
      },
      {
        question: 'Hesap gerekiyor mu?',
        answer:
          'Hayır. Bir ad yazarsın, tıklarsın, oynarsın. Hesap yalnızca adı ve avatarı bir oyundan ötekine taşır: isteğe bağlı kalır.',
      },
      {
        question: 'Telefonda çalışıyor mu?',
        answer:
          'Evet, arayüz dokunmaya uyum sağlar: katlanmış araç çubuğu, parmağın altında büyüteç, yakınlaştırmak için çift dokunuş. Yine de fareyle ve büyük ekranda daha hassas çizilir.',
      },
      {
        question: 'Arkadaşlarımı nasıl davet ederim?',
        answer:
          'Bir oda kurarsın, davet bağlantısını kopyalayıp istediğin yere yapıştırırsın. Arkadaşların doğrudan masaya iner, hesapsız ve kurulumsuz.',
      },
      {
        question: '“Rötuş” ne demek?',
        answer:
          'Silinmiş alana çizdiğin şey. Tuttuğunda özgün tablonun bir parçası sanılır ve kimse onu bulamaz. Tutmadığında göze batar.',
      },
    ],
    headings: {
      intro: 'Kaybolmayı gerektiren bir çizim oyunu',
      steps: 'Nasıl oynanır',
      modes: 'Altı oyun modu',
      faq: 'Sık sorulan sorular',
      more: 'Daha fazlası',
    },
    links: {
      rules: 'Tüm kuralları ve puanlamayı oku',
      modes: 'Modları ayrıntılı karşılaştır',
    },
  },

  howToPlay: {
    title: 'Retusch nasıl oynanır',
    summary:
      'Retusch’un tüm kuralları: bir turun akışı, iki taraftaki puanlama, çizim araçları ve hem saklanmak hem aramak için ipuçları.',
    sections: [
      {
        heading: 'Üç cümlede fikir',
        blocks: [
          'Bir alanı silinmiş bir tablo alırsın ve o alanı fark edilmeyecek biçimde yeniden çizersin.',
          'Sonra herkes rötuşlanmış tablolara bakar ve yeniden çizilmiş alanları arar.',
          'Çabuk bularak puan alırsın, saklanma yerin dayandığı sürece de puan alırsın.',
        ],
      },
      {
        heading: 'Bir turun akışı',
        blocks: [
          'Bir oyun aynı turları arka arkaya bağlar, varsayılan olarak beş tane. Her tur üç andan geçer.',
          {
            list: [
              'Çizim. Tablonu ve alanını alırsın, yeniden çizmek için varsayılan olarak 2 dakikan olur. Bitti düğmesi teslim demektir: herkes teslim ettiği anda tur, süreyi beklemeden ilerler.',
              'Av. Tablo rötuşlarla birlikte geri gelir ve onları fark etmek için varsayılan olarak 30 saniyen olur. Yeniden çizilmiş bir alana tıklamak onu bütün masaya açar.',
              'Açığa çıkış. Bütün saklanma yerleri çerçevelenir ve adlandırılır, kimsenin görmedikleri de dahil. Bir kaydırıcı, rötuşlanmış tabloyla özgün eseri karşılaştırmanı sağlar.',
            ],
          },
        ],
      },
      {
        heading: 'Puanlama',
        blocks: [
          'İki sayaç birlikte işler ve birbirine ters düşer: arayan çabuk olmak ister, çizen ise alanının dayanmasını.',
          {
            list: [
              'Arayan için: ilk 3 saniyede bulursan 1000 puan, sonra aşamanın sonundaki 100 puana doğru düzenli bir düşüş. Yanılmak ya da hiçbir şey bulamamak hiçbir şey getirmez.',
              'Çizen için: alanın hemen düşerse yalnızca 100 puan, sonra sona kadar dayanırsa 800 puana kadar düzenli bir artış. Kimsenin bulamadığı bir rötuş en yükseği, 800 puanı verir.',
            ],
          },
          'Çizen yalnızca bir kez, açığa çıkışta ödenir ve en hızlı arayana göre. Bu yüzden seni iki kişinin mi sekiz kişinin mi aradığı fark etmez: yalnızca seni ilk bulan sayılır.',
          'Aşamaya hangi süreyi verirsen ver puanlama aynıdır. Avı uzatmak iki uç değeri kaydırmaz, yalnızca aralarındaki eğimi değiştirir.',
          'Tur başına tek bir hata. Hiçbir rötuşa değmeyen ilk tıklama avını kapatır: bu kural olmasa, denk gelene kadar görüntü rastgele taranırdı. İki hareket hiçbir şeye mal olmaz: kendi alanına tıklamak ve zaten bulunmuş bir rötuşa tıklamak.',
        ],
      },
      {
        heading: 'Çizim araçları',
        blocks: [
          {
            list: [
              'Fırça (B): üç hızlı boyut, artı tam boyut için bir kaydırıcı. 1, 2 ve 3 kısayolları üç boyutu seçer.',
              'Boya kovası (P): düz bir yüzeyi tek seferde doldurur ve alanının dışına asla taşmaz.',
              'Damlalık (I): tablonun herhangi bir yerinden renk alır. Alt tuşunu basılı tutmak bir tıklamalığına ona geçirir, sonra önceki aracı geri verir.',
              'El (H): görünümü kaydırır. Alanının dışında fırça ve boya kovası da aynısını yapar, bu yüzden neredeyse hiç araç değiştirmen gerekmez.',
              'Geri al (Ctrl+Z ya da Cmd+Z): otuz kez, fırça darbesi başına geri gider. İleri al yoktur.',
              'Paletin sonundaki zemin rengi: alanının başlangıç rengidir. Onunla boyamak silmek demektir, tek farkı bunun da geri alınabilen ve üstü kapatılabilen sıradan bir fırça darbesi olması. Oyunda silgi bu yüzden yok.',
            ],
          },
        ],
      },
      {
        heading: 'Saklanmak için beş ipucu',
        blocks: [
          {
            list: [
              'Renkleri tahmin etme, damlalıkla al. Damlalık çevrenin tam rengini verir: azıcık kaymış bir yüzey uzaktan belli olur, tam olanıysa görünmez olur.',
              'Alanını kesip geçeni uzat. Bir duvar, bir ufuk çizgisi, bir yandan giren bir dal öteki yandan tam yerinde çıkmalı. Kesilmiş bir çizgi, deneyimli bir oyuncunun aradığı ilk ipucudur.',
              'Önce köşeleri boya. En sık yapılan hata bu: merkez özenle işlenir, dört köşe başlangıç zemininde kalır ve kare, çizime bakmaya bile gerek kalmadan çıplak gözle görünür.',
              'Genelden ayrıntıya git. Önce kalın bir fırçayla büyük renk kütlelerini yerleştir, sonra inceleştir. Tersi yapılırsa bütün süre tek bir köşeye gider, gerisi boş kalır.',
              'Çevrenin ayrıntı düzeyini taklit et. Yoğun bir bölgenin ortasındaki fazla temiz bir alan, düz bir yüzeyin ortasındaki özensiz bir alan kadar belli olur.',
            ],
          },
        ],
      },
      {
        heading: 'Aramak için dört ipucu',
        blocks: [
          {
            list: [
              'Kesilen çizgileri ara. Bir kenar, bir kablo, kıl payı kayan bir masa köşesi: neredeyse her zaman oradadır.',
              'Önce tara, sonra yakınlaştır. Tam görünümde kötü karışmış bir alan leke gibi durur. Yakınlaştırma doğrulamak içindir, aramak için değil.',
              'Fazla pürüzsüz olandan şüphelen. Dokunun ortasındaki kusursuz düzgün bir yüzey, özensiz bir leke kadar şüphelidir.',
              'Rastgele tıklama. Tek bir hata hakkın var: kontrol için üç saniye kaybetmek, bütün turu kaybetmekten iyidir.',
            ],
          },
        ],
      },
      {
        heading: 'Peki moda göre?',
        blocks: [
          'Yukarıdaki her şey varsayılan mod olan ortak avı anlatır. Öteki modlar kimin çizdiğini, kimin aradığını ve nasıl kazanıldığını değiştirir: her birinin ayrıntısı oyun modları sayfasında.',
        ],
      },
    ],
  },

  modes: {
    title: 'Retusch’un oyun modları',
    summary:
      'Retusch’u oynamanın altı yolu: ortak av, yayın, herkese kendi tablosu, tek kişi çizer, battle royale ve yarışma. Akış, önerilen oyuncu sayısı ve süre.',
    sections: [
      {
        heading: 'Ortak av',
        blocks: [
          'Varsayılan mod, ve başlamaya değer olan.',
          'Herkes aynı tabloya çizer, her biri kendi alanına. Rötuşlar teslim edildiğinde eser bütün olarak geri döner ve av herkes için aynı anda açılır. Bir rötuş yalnızca bir kez bulunur, onu ilk fark eden tarafından: o an bütün masaya görünür ve oyundan çıkar. Kendininkini asla bulamazsın ve kimsenin görmediği bir saklanma yeri sahibine en yükseği verir.',
          'Kalabalık bir grup için ideal: ölü an yoktur, herkes aynı anda arar ve her buluş herkesin ekranında belirir.',
          'Önerilen: 3 ile 10 oyuncu.',
        ],
      },
      {
        heading: 'Yayın',
        blocks: [
          '“Tek kişi çizer” modunun ayna görüntüsü, canlı yayın için tasarlandı.',
          'Kurucu dışında bütün oyuncular aynı tabloya çizer. Sonra yalnızca kurucu arar, izleyicileri onun zorlanmasını seyrederken. Puan almaz ve sıralamada yer almaz: oyun saklananlar arasında geçer, o avı yürütür. İstediği kadar yanılabilir, tek hata kuralı onun için geçerli değildir.',
          'Canlı yayınlı bir akşam için ideal, hem de belirli bir nedenle: kurucu çizmediği için izleyiciler onun saklanma yerinin kurulduğunu hiç görmez. Öteki modlarda onu kendi alanını boyarken izlerler ve avın onlar için hiçbir gizemi kalmaz.',
          'Önerilen: 4 ile 10 oyuncu. Ücretsiz, ve öyle kalacak.',
        ],
      },
      {
        heading: 'Herkese kendi tablosu',
        blocks: [
          'Her oyuncu kendi eserini alır ve rötuşunu onun içine saklar. Av sırasında sana yalnızca bir başka kişinin tablosu verilir ve yeniden çizilmiş alanı göstermek için tek bir tıklaman olur. Yarış yok, rekabet yok: yalnızca sen, bir tablo ve bir karar.',
          'İki kişi için ideal, ya da herkesin acele etmediği sakin bir oyun istendiğinde.',
          'Önerilen: 2 ile 10 oyuncu.',
        ],
      },
      {
        heading: 'Tek kişi çizer',
        blocks: [
          'Bir tur, bir çizen, geri kalan herkes peşinde.',
          'Her turda tek bir kişi tablo alır. Ötekiler bekler, sonra onun rötuşunu arar; her biri kendi süresine göre değerlendirilir. Çizen en hızlı arayana göre değerlendirilir ve saklanma yerini, aranırken donmuş halde yeniden görür. Rol sırayla dolaşır: burada tur ayarı tam devirleri sayar, çünkü bir oyun ancak herkes aynı sayıda çizdiyse adildir.',
          'Eşit koşullarda, çizim çizim ölçüşmek isteyen küçük bir grup için ideal.',
          'Önerilen: 3 ile 6 oyuncu, daha fazlasında bekleme uzuyor.',
        ],
      },
      {
        heading: 'Battle royale',
        blocks: [
          'Ortak av, tur başına bir elemeyle.',
          'Aynı ortak tablo, aynı eşzamanlı av. Ama burada tek bir puan sayılmaz: tek soru kimin kaldığıdır. Rötuşu ilk bulunan oyuncu oyundan ayrılır. Ötekiler turun sonuna kadar aramayı sürdürür; bu artık kimseyi elemez ama herkese kendi alanında gösterilen bir tur sıralaması verir. Kimse bulunmazsa kimse çıkmaz.',
          'Bir akşamı kapatmak için ideal: masa boşaldıkça gerilim artar ve son tur iki kişi arasında oynanır.',
          'Önerilen: 4 ile 10 oyuncu.',
        ],
      },
      {
        heading: 'Yarışma',
        blocks: [
          'Kimsenin aramadığı tek mod.',
          'Herkes aynı tablonun aynı alanını yeniden çizer. Sonra herkes kendi hızında ötekilerin rötuşlarını gezer ve en başarılı bulduğuna oy verir. Alınan her oy sahibine bir puan kazandırır. Oylama sırasında sahipler adsızdır ve kendine oy verilemez: adlar ve oylar ancak açığa çıkışta ortaya çıkar.',
          'Grup karışık olduğunda ideal, ya da biri av süresinin baskısı olmadan çizmeyi tercih ettiğinde.',
          'Önerilen: 3 ile 10 oyuncu.',
        ],
      },
    ],
  },
  modeTable: [
    { name: 'Ortak av', players: '3 ile 10', duration: '15-20 dk' },
    { name: 'Yayın', players: '4 ile 10', duration: '15-20 dk' },
    { name: 'Herkese kendi tablosu', players: '2 ile 10', duration: '15-20 dk' },
    { name: 'Tek kişi çizer', players: '3 ile 6', duration: '20-35 dk' },
    { name: 'Battle royale', players: '4 ile 10', duration: '20-30 dk' },
    { name: 'Yarışma', players: '3 ile 10', duration: '10-15 dk' },
  ],
  modeTableHeadings: ['Mod', 'Oyuncular', 'Süre'],
  premium: {
    heading: 'Ücretsiz modlar ve ücretli modlar',
    blocks: [
      'Ortak av ve yayın modu kalıcı olarak ücretsizdir.',
      'Öteki dördü bir oyunun KURULMASINDA ücretli olacak, yalnızca orada. Katılmak her zaman ücretsiz kalacak: masadaki tek bir kişinin oyunun kilidini açmış olması, herkesin bütün modları hesapsız ve ödemesiz oynayabilmesi için yeter.',
      'Kilidi açmak abonesiz, tek seferlik bir satın alma olacak ve bunu yapan hesaptan reklamları da kaldıracak. O zamana kadar bütün modlar herkese açık.',
    ],
  },

  blog: [
    {
      slug: 'quest-ce-que-retusch',
      title: 'Retusch nedir?',
      date: '2026-08-21',
      summary:
        'Çok kişiyle oynanan bir çevrimiçi çizim oyunu; biçim olarak Gartic Phone’a yakın, ama mekaniği Meccha Chameleon’u andırıyor: tanınmak yerine kaybolmaya çalışıyorsun.',
      sections: [
        {
          heading: 'Tanınmanın kaybetmek olduğu bir çizim oyunu',
          blocks: [
            'Retusch, 2 ile 10 oyuncu için bir çevrimiçi çizim oyunudur. Her turda bir alanı silinmiş bir çizim alırsın ve o alanı esere karışacak biçimde yeniden çizmen gerekir. Sonra herkes rötuşlanmış tablolara bakar ve yeniden çizilmiş alanları arar.',
            'Onu ayıran şey tek bir cümleye sığıyor: kazanmak, görülmemek demektir.',
          ],
        },
        {
          heading: 'Gartic Phone ile paylaştıkları',
          blocks: [
            'Biçim aynı: bir bağlantı açarsın, bir ad yazarsın, oynarsın. Hesap yok, kurulum yok, indirilecek istemci yok. Oyun tarayıcıda çalışır ve bir parti birkaç saniyede başlar. Arkadaşlarını bir sohbete bağlantı yapıştırarak davet edersin ve masa dolar.',
            'Ritim de tanıdık: kısa turlar, bir sayaç, bir çizim aşaması ve ardından ötekilerin ne ürettiğinin ortaya çıktığı bir aşama. Ve özellikle tur sonundaki o toplu açığa çıkış, herkesin gördüğü şey üzerine laf ettiği an. Aynı topluca alınan keyif.',
            'Gartic Phone’da olduğu gibi, çizmeyi bilmek gerekmiyor. İyi yerleştirilmiş bir gökyüzü parçası, taşan bir başyapıtı yener.',
          ],
        },
        {
          heading: 'Meccha Chameleon’dan aldıkları',
          blocks: [
            'Derinde ise mekanik başka yerde. Steam’deki üç boyutlu oyun Meccha Chameleon’da kendi karakterini boyar, sonra onu bir dekorun içine yerleştirirsin; kimse onu çevresinden ayırt edemesin diye. Zafer benzerlikten ve iyi yerleştirmeden gelir, aksiyondan değil.',
            'Retusch bu fikri alır ve görüntüye geri getirir. Nereye saklanacağını sen seçmezsin, alanı oyun verir; buna karşılık içine girecek her şeyi baştan sona sen üretirsin. Saklanma yeri, bakış üzerinden durmadan kayıp geçiyorsa tutmuştur.',
            'Ve her taklit oyununda olduğu gibi, gerilim çifte rolden doğar. Aynı anda hem saklanan hem avcısın: sen tabloyu şüpheli bir yüzey arayarak tararken, biri seninkini tarıyor.',
          ],
        },
        {
          heading: 'Başka hiçbir yerde olmayan',
          blocks: [
            'Puanlama iki tarafı ters yönde ödüllendirir. Arayan ne kadar çabuk bulursa o kadar çok puan alır; çizen ise alanı ne kadar uzun dayanırsa o kadar çok alır. Kimsenin görmediği bir rötuş sahibine en yükseği verir.',
            'Bundan çok özel bir oynayış doğar: güzel yapmaya değil, tam yapmaya çalışırsın. Doğru rengi almak, bir çizgiyi tam gerektiği yerde uzatmak, hiçbir köşeyi boş bırakmamak. Bunlar çizim hareketlerinden önce gözlem hareketleridir.',
            'Uygulamada anlamanın en kolay yolu tüm kuralları okumak ya da hızlı bir oyun başlatmaktır: ayarsız ve beklemesiz başlar.',
          ],
        },
      ],
    },
    {
      slug: 'comment-etre-imbattable',
      title: 'Retusch’ta nasıl yenilmez olunur',
      date: '2026-08-21',
      summary:
        'Klavye kısayolları, genelden ayrıntıya yöntemi ve boş köşeler hatası: bir acemiyi, artık bulunamayan bir oyuncudan ayıran üç şey.',
      sections: [
        {
          heading: 'Kısayolları öğren, yararlı süreyi ikiye katla',
          blocks: [
            'Her araca fareyle gidilirse iki dakikalık çizim çok çabuk tükenir. Kısayollar tur başına rahatlıkla yirmi otuz saniye kazandırır ve tam da o saniyeleri ayrıntılara ayırırsın.',
            {
              list: [
                'Fırça için B, boya kovası için P, damlalık için I, el için H.',
                'Araç çubuğuna uğramadan, üç fırça boyutu için 1, 2 ve 3.',
                'Fırça darbesi başına geri almak için Ctrl+Z, Mac’te Cmd+Z.',
                'Alt tuşunu basılı tutmak damlalığa geçirir ve bıraktığın anda önceki aracı geri verir. Hepsinin en yararlısı bu: iş üstündeyken hiç araç değiştirmeden renk alırsın.',
              ],
            },
            'AZERTY klavyeler için bir not: klavyende üzerlerinde &, é ve " yazsa bile 1, 2 ve 3 tuşları Shift olmadan çalışır. Oyun tuşun konumunu okur, ürettiği karakteri değil.',
          ],
        },
        {
          heading: 'Genelden ayrıntıya boya',
          blocks: [
            'Klasik acemi hatası bir köşeden başlayıp onu özenle işlemektir. Süre biter, alanın dörtte üçü hâlâ zemindir ve rötuş on metreden görünür.',
            'Doğru yöntem tam tersi. Kalın bir fırçayla ya da boya kovasıyla başla ve büyük renk kütlelerini yerleştir: gökyüzünü, duvarı, yerdeki gölgeyi. Yirmi saniyede alanın doğru genel görünüşe kavuşur ve artık yabancı bir blok gibi okunmaz.',
            'Ancak ondan sonra boyutu küçült ve geçişleri işle: kesip geçen ufuk çizgisini, bir nesnenin kenarını, yarı yükseklikte değişen renk geçişini. Süre yetmezse ayrıntıyı kaybedersin, turu değil.',
            'Renkleri paletten seçmek yerine hep damlalıkla al. Yaklaşık bir ton koca bir alanı ele vermeye yeter, tam ton ise onu görünmez kılar.',
          ],
        },
        {
          heading: 'Köşeleri asla boş bırakma',
          blocks: [
            'Bir numaralı ipucu bu, ve deneyimli oyuncuların ilk aradığı şey. Merkezi güzelce işlenmiş ama dört köşesi zemin renginde kalmış bir alan, ekrana kusursuz bir dikdörtgen çizer. Çizime bakmaya bile gerek yok: geometrik biçim göze batar.',
            'Önce kenarı, sonra merkezi işlemeyi alışkanlık edin. İyi karışmış bir çerçeve, yaklaşık bir içi affeder; tersi asla doğru değildir.',
            'Kenarlardan bilerek taş. Oyun fırça darbeni alanın sınırında keser, yani çok daha ileri gitmekle hiçbir şey riske atmazsın; bir köşede tek bir zemin pikselinin bile sağ kalmadığından emin olmanın tek yolu budur.',
          ],
        },
        {
          heading: 'Sıra sende aramaya geldiğinde',
          blocks: [
            'Önce yakınlaştırmadan tabloyu baştan sona tara: kötü karışmış bir alan leke gibi durur, yakınlaştırma yalnızca doğrulamaya yarar. Sonra uzun çizgileri, görüntüyü kesip geçenleri izle: kıl payı kaymış bir kenar neredeyse her zaman bir rötuştur.',
            'Ve tur başına tek bir hata hakkın olduğunu unutma. Üç saniyelik bir kontrol, bütün turdan ucuza gelir.',
          ],
        },
      ],
    },
    {
      slug: 'jeu-de-dessin-entre-amis',
      title: 'Arkadaşlarla oynanacak bir çizim oyunu',
      date: '2026-08-21',
      summary:
        'Retusch küçük grupta neden iyi işliyor, bağlantı yapıştırarak nasıl davet edilir ve ücretli modların bütün masaya açılması için neden tek bir oyuncu yetiyor.',
      sections: [
        {
          heading: 'Kimseden hiçbir şey istemeyen bir oyun',
          blocks: [
            'Uzaktan bir oyun akşamının en büyük engeli kurulumdur. Açılacak bir hesap, indirilecek bir istemci, tutmayan bir sürüm: grubun yarısı daha oynamadan vazgeçer.',
            'Retusch tarayıcıda çalışır. Arkadaşların bir bağlantıya tıklar, bir ad yazar ve kendilerini masada bulurlar. Kurulacak bir şey yok, açılacak bir şey yok, hem bilgisayarda hem telefonda iyi çalışır.',
            'Grupta önemli bir şey daha: kimse çizmeyi bilmediği için dışarıda kalmaz. Oyun bir şeyi resmetmeni istemez, yalnızca bir alanı onu çevreleyen şeye uydurmanı ister. Kötü çizen ama iyi gözlemleyen sık sık kazanır.',
          ],
        },
        {
          heading: 'Uygulamada davet',
          blocks: [
            'Başlangıç ekranından bir oda kur. Kendi aranızda kalmak istiyorsanız “herkese açık oda” kutusunun işaretini kaldır: bağlantıyla davet o zaman tek giriş yolu olur.',
            'Bağlantıyı ilgili düğmeyle kopyala, sonra grup sohbetinize, sesli kanalınıza ya da mesajlaşmanıza yapıştır. İçinde oda kodu vardır: arkadaşların doğrudan senin masana iner.',
            'İnsanlar gelirken oyunu ayarlayabilirsin: modu, tur sayısını, çizim süresini, alan boyutunu, hatta görsel kategorilerini. Sen başlatana kadar hiçbir şey kesin değildir.',
          ],
        },
        {
          heading: 'Biri öder, herkes oynar',
          blocks: [
            'İki mod sonsuza kadar ücretsiz: varsayılan olan ortak av ve yayın modu.',
            'Ötekiler ücretli olacak, ama yalnızca bir oyunun KURULMASINDA. Katılmak koşulsuz olarak ücretsiz kalacak. Uygulamada gruptan tek bir kişinin oyunun kilidini açmış olması, bütün masanın hesapsız ve hiçbir ödeme yapmadan tüm modların tadını çıkarması için yeter.',
            'Kilidi açmak abonesiz, tek seferlik bir satın almadır.',
          ],
        },
        {
          heading: 'Hangi grup için hangi mod',
          blocks: [
            'Üç dört kişide ortak av yeter ve bir turda anlaşılır. Altı kişiden sonra gerçekten iyi olur: buluşlar peş peşe gelir ve ekran durmadan hareket eder.',
            'Bir akşamı kapatmak için battle royale’i deneyin: masa tur tur boşalır ve sonuncusu iki kişi arasında oynanır. Birinin sakin sakin çizmeyi tercih ettiği karışık bir grup için yarışma, av süresinin bütün baskısını kaldırır.',
          ],
        },
      ],
    },
    {
      slug: 'jeu-de-dessin-en-stream',
      title: 'Canlı yayında oynanacak bir çizim oyunu',
      date: '2026-08-21',
      summary:
        'Retusch’un canlı yayın için tasarlanmış bir modu var; yayıncı tek başına ararken izleyicileri saklanıyor. Nasıl kullanılır ve seyirci önünde başka hangi modlar işler.',
      sections: [
        {
          heading: 'Özel olarak yapılmış bir mod',
          blocks: [
            'Yayın modu rolleri tersine çevirir. Hiç çizmeyen kurucu dışında bütün oyuncular aynı tabloya çizer. Sonra izleyicileri seyrederken yalnızca kurucu arar.',
            'Bir canlı yayının istediği durum tam olarak budur, hem de belirli bir nedenle: kurucu çizmediği için saklanma yeri yoktur ve sohbet görmemesi gereken hiçbir şeyi görmemiştir. Buna karşılık izleyiciler öteki oyuncuların saklanma yerlerini bilir ve onun art arda üç kez yanlarından geçişini izleyebilir.',
            'Bu durum için iki kural yazıldı. Yayıncı puan almaz ve sıralamada yer almaz: oyun saklananlar arasında geçer, o gösteriyi yürütür. Ve istediği kadar yanılabilir, oysa bütün öteki modlar ilk hatada durur. Bir canlı yayın talihsiz bir tıklamayla bitemez.',
            'Yayın modu ücretsiz, ve öyle kalacak.',
          ],
        },
        {
          heading: 'Yarışma, ikinci iyi fikir',
          blocks: [
            'Yarışma modunda herkes aynı tablonun aynı alanını yeniden çizer, sonra herkes en beğendiği rötuşa oy verir. Artık bulunacak bir şey yoktur, yalnızca değerlendirilecek.',
            'Seyirci önünde çok iyi işler, hem de yayın moduyla aynı nedenle: bulunacak bir şey yoktur, dolayısıyla sohbetin bozabileceği bir şey de yoktur. Çalışmalar yan yana karşılaştırılır, oylama bir merak anı yaratır ve adların açıklanması net bir kapanış sunar. Ayrıca en kısa mod budur.',
          ],
        },
        {
          heading: 'Ve öteki modlar',
          blocks: [
            'Hiçbir şey özel bir modu zorunlu kılmıyor, ama o zaman sohbetle değil arkadaşlarla oynamak daha iyi olur. Bütün öteki modlarda yayıncı kendi alanını ekranda boyar: izleyiciler onun kurulduğunu görür ve av daha başlamadan cevabı bilirler.',
            'Arkadaşlar arasındaki bir parti ise dışarıdan çok iyi izlenir: çizim aşaması herkesin saklanma yerini nasıl kurduğunu gösterir, açığa çıkış ise bütün alanları sahibinin adıyla birlikte tek seferde açar.',
          ],
        },
        {
          heading: 'Sohbeti oyuna katmak',
          blocks: [
            'Paylaşılacak tek şey davet bağlantısıdır. Onu sohbete yapıştır, ilk gelenler masayı doldurur: açılacak hesap yok, indirme yok, sıra beklemek yok.',
            'Oyuncu sınırı odada, 2 ile 10 arasında ayarlanır. Kalabalık bir izleyici kitlesiyle tek bir uzun parti yerine birkaç kısa parti aç: bir tur üç dakikadan az sürer.',
          ],
        },
      ],
    },
    {
      slug: 'nouveautes',
      title: 'Retusch’ta yenilikler',
      date: '2026-08-21',
      summary:
        'Retusch’a gelen oyun değişiklikleri, en yeniden en eskiye: yeni modlar, yeni kurallar, çizimde ve avda iyileştirmeler.',
      sections: [
        {
          heading: 'Ağustos 2026',
          blocks: [
            {
              list: [
                'Yeniden çizilecek alan artık beyaz bir kareden değil, örttüğü şeyin baskın renginden başlıyor. Tabloda hiç bulunmayan bir zemini yeniden boyamakla sürenin yarısı gitmiyor.',
                'Boya kovası artık fırça darbelerinin boyunca açık renk bir kenar bırakmıyor: bundan böyle onların yumuşatılmış kenarının altına giriyor.',
                'Battle royale artık puan saymıyor. İlk bulunan oyuncu oyundan ayrılıyor ve herkes kendi alanında kırmızıdan yeşile gösterilen bir tur sıralaması alıyor.',
                'Yayın modu yayıncıya istediği kadar deneme veriyor: ilk hata artık turu kapatmıyor.',
                'İzleyici modunda artık kurulmasını seyrettiğin tabloyu kaydırıp yakınlaştırabiliyorsun.',
                'Emoji tepkileri ekranın altından yükselmek yerine oyuncu listesindeki sahibinin adından yola çıkıyor.',
                'Yeniden çizilecek alanın dışında fırça ve boya kovası görünümü kaydırıyor: hareket etmek için artık el aracını almak gerekmiyor.',
                'Bir parti sırasında sol üstteki oyun adı, onaydan sonra başlangıç sayfasına geri götürüyor.',
                'Japonca ve Korece, hâlihazırdaki on beş dile ekleniyor.',
              ],
            },
          ],
        },
        {
          heading: 'Temmuz 2026',
          blocks: [
            {
              list: [
                'Yeni yarışma modu: herkes aynı alanı yeniden çiziyor, sonra herkes en beğendiği rötuşa oy veriyor.',
                'Canlı yayın için tasarlanmış yeni yayın modu: kurucu tek başına ararken izleyicileri saklanıyor.',
                'Görsel kategorileri zorluk düzeylerinin yerini alıyor. Görmek istediklerini işaretliyorsun ve her kategori örnek bir tablo gösteriyor.',
                'Arka arkaya iki tur artık aynı tabloya denk gelmiyor ve işaretlenen kategoriler turdan tura değişiyor.',
                'Oyun sonu galerisi bir rötuşu fırça darbesi fırça darbesi yeniden izlemeye ve görüntü ya da hareketli GIF olarak dışa aktarmaya izin veriyor.',
              ],
            },
          ],
        },
      ],
    },
  ],

  ui: {
    atAGlance: 'Kısaca',
    allArticles: 'Bütün yazılar',
    theRules: 'Oyunun kuralları',
    theModes: 'Oyun modları',
  },
};
